import React from "react"
// import { Alert } from "~/ui/primitives"
import Clipboard from "~/ui/clipboard"
import styled from '~/ui/styled'
import { globalToast } from "~utils"

const Text = styled.Text``

const ErrorText = styled.Text`
  color: red;
`

const Title = styled.Text`
  padding: 8px;
`

const onCopy = (v: string) => {
  Clipboard.setString(v)
  globalToast.show("复制成功")
}

const URI = ({ uri }) => <Text onClick={() => onCopy(uri)}>url: {uri}</Text>
const State = ({ state }) => <Text>State: {state}</Text>
const Error = ({ error }) => (error ? <ErrorText>{error}</ErrorText> : null)

const Container = styled.View``

const Content = styled.View`
  padding: 8px;
  background-color: #fff;
`

interface Props {
  uri: string
  error: string | undefined
  state: number
}

const ServerInfo: React.FC<Props> = ({ uri, error, state }) => {
  return (
    <Container>
      <Title>服务器状态</Title>
      <Content>
        <URI uri={uri} />
        <State state={state} />
        <Error error={error} />
      </Content>
    </Container>
  )
}

export default ServerInfo
